global.env = global.env || {}

export const hosts = require('./hosts.json')

export const mixpanelId = '1d3bc291242a2a84a2aec534c7f5feb5'
export const powerformEndpoint = '/Member/PowerFormSigning.aspx'
export const enableMonitoring = true
export const enablePseudoLoc = false
export const debug = false
